var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleACall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 19,
    fill: "white",
    stroke: "#FF8C69",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.97 31.33C35.97 31.69 35.89 32.06 35.72 32.42C35.55 32.78 35.33 33.12 35.04 33.44C34.55 33.98 34.01 34.37 33.4 34.62C32.8 34.87 32.15 35 31.45 35C30.43 35 29.34 34.76 28.19 34.27C27.04 33.78 25.89 33.12 24.75 32.29C23.6 31.45 22.51 30.52 21.47 29.49C20.44 28.45 19.51 27.36 18.68 26.22C17.86 25.08 17.2 23.94 16.72 22.81C16.24 21.67 16 20.58 16 19.54C16 18.86 16.12 18.21 16.36 17.61C16.6 17 16.98 16.44 17.51 15.94C18.15 15.31 18.85 15 19.59 15C19.87 15 20.15 15.06 20.4 15.18C20.66 15.3 20.89 15.48 21.07 15.74L23.39 19.01C23.57 19.26 23.7 19.49 23.79 19.71C23.88 19.92 23.93 20.13 23.93 20.32C23.93 20.56 23.86 20.8 23.72 21.03C23.59 21.26 23.4 21.5 23.16 21.74L22.4 22.53C22.29 22.64 22.24 22.77 22.24 22.93C22.24 23.01 22.25 23.08 22.27 23.16C22.3 23.24 22.33 23.3 22.35 23.36C22.53 23.69 22.84 24.12 23.28 24.64C23.73 25.16 24.21 25.69 24.73 26.22C25.27 26.75 25.79 27.24 26.32 27.69C26.84 28.13 27.27 28.43 27.61 28.61C27.66 28.63 27.72 28.66 27.79 28.69C27.87 28.72 27.95 28.73 28.04 28.73C28.21 28.73 28.34 28.67 28.45 28.56L29.21 27.81C29.46 27.56 29.7 27.37 29.93 27.25C30.16 27.11 30.39 27.04 30.64 27.04C30.83 27.04 31.03 27.08 31.25 27.17C31.47 27.26 31.7 27.39 31.95 27.56L35.26 29.91C35.52 30.09 35.7 30.3 35.81 30.55C35.91 30.8 35.97 31.05 35.97 31.33Z",
    stroke: "#213332",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22C32.5 21.4 32.03 20.48 31.33 19.73C30.69 19.04 29.84 18.5 29 18.5",
    stroke: "#213332",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22C36 18.13 32.87 15 29 15",
    stroke: "#213332",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleACall);
export default __webpack_public_path__ + "static/media/schedule_a_call.5dad7af8925407621ae9844dcd9119c9.svg";
export { ForwardRef as ReactComponent };